import { CSSProperties } from 'react'
import Colors from 'modules/Colors'

interface ArrowUpRightIconProps {
    className?: string
    style?: CSSProperties
    color?: string
    size?: number
    onClick?: () => void
}

const ArrowUpRightIcon = ({
    color = Colors.purple,
    size = 24,
    className,
    style,
    onClick
}: ArrowUpRightIconProps) => {
    return (
        <svg
            className={className}
            style={style}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
        >
            <path
                d="M16.8821 8.7265L7.46185 15.3226"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
            />
            <path
                d="M16.3094 14.0106L17.118 9.42453C17.2139 8.88065 16.8507 8.36197 16.3069 8.26609L11.7208 7.45743"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
            />
        </svg>
    )
}

export default ArrowUpRightIcon
